<div class="insight-customize">
    <button
        class="btn bg-transparent pr-0 pl-0"
        [cmpsOverlayTrigger]="filterTpl"
        placement="bottom-left"
    >
        <cmps-icon
            class="cmps-cdk-fill-blue-100 cmps-cdk-mr-0dot5"
            svgIcon="cog"
        ></cmps-icon>
        <span>
            {{ _i18n._11165_CUSTOMIZE | translate }}
        </span>
    </button>
    <ng-template #filterTpl>
        <div
            class="cmps-cdk-border-width-1p cmps-cdk-border-solid cmps-cdk-border-color-grey-300 insight-customize insight-pop-up-content insight-scrollable"
        >
            <div class="col">
                <div class="row">
                    <ng-container *ngIf="pillars">
                        <div
                            class="col-6"
                            [class.mb-3]="_count > 2"
                        >
                            <div class="row">
                                <div class="col">
                                    <div class="insight-title">
                                        {{ _i18n._801_PILLARS | translate }}
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <customize-pillars-insight
                                        [pillars]="pillarsPillars"
                                        [selection]="pillarsSelection"
                                        [canSelect]="pillarsCanSelect"
                                        (change)="
                                            pillarsSelectionChange?.emit($event)
                                        "
                                    >
                                    </customize-pillars-insight>
                                </div>
                            </div>
                        </div>
                    </ng-container>

                    <div
                        class="cmps-cdk-border-r-width-1px cmps-cdk-border-r-solid cmps-cdk-border-r-color-grey-300 insight-separator"
                        [class.mb-3]="_count > 2"
                        *ngIf="pillars && columns"
                    ></div>

                    <ng-container *ngIf="columns">
                        <div
                            class="col-6"
                            [class.mb-3]="_count > 2"
                        >
                            <div class="row">
                                <div class="col">
                                    <div class="insight-title">
                                        {{ _i18n._7511_COLUMNS | translate }}
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <customize-columns-insight
                                        [columns]="columnsColumns"
                                        [selection]="columnsSelection"
                                        (change)="
                                            columnsSelectionChange?.emit($event)
                                        "
                                    ></customize-columns-insight>
                                </div>
                            </div>
                        </div>
                    </ng-container>

                    <div
                        class="cmps-cdk-border-r-width-1px cmps-cdk-border-r-solid cmps-cdk-border-r-color-grey-300 insight-separator"
                        [class.mb-3]="_count > 2"
                        *ngIf="columns && metrics"
                    ></div>

                    <ng-container *ngIf="metrics">
                        <div class="col-6">
                            <div class="row">
                                <div class="col">
                                    <div class="insight-title">
                                        {{ _i18n._527_METRICS | translate }}
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <customize-metrics-insight
                                        [metrics]="metricsMetrics"
                                        [pillars]="metricsPillars"
                                        [selection]="metricsSelection"
                                        [canSelect]="metricsCanSelect"
                                        (change)="
                                            metricsSelectionChange?.emit($event)
                                        "
                                    ></customize-metrics-insight>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </ng-template>
</div>
